import { SvgReliefComposer } from '@modules/Vector/S/Function/composite/svg.relief-composer.ts';
import { MakerProfile } from '@modules/NewMaker/FlexiMaker/F/Function/flexmaker.types.ts';
import { JOGAK_STIKER_PRODUCT, PLUSH_PRODUCT } from '@modules/NewMaker/FlexiMaker/S/Constant/fleximaker';
import { RELIEF_OPTIONS } from '@modules/Vector/S/Constant/doll.constant.ts';
import { SvgUtil } from '@modules/Vector/S/Function/util.svg.ts';
import { mapRange } from '@modules/NewMaker/FlexiMaker/F/Function/flexmaker.helper.ts';

const DefaultProfile: MakerProfile = {
  name: 'default',
  shouldApply: () => true,
};

// 3) 봉제인형 전용
const PlushProfile: MakerProfile = {
  name: 'plush',
  shouldApply: ({ bpId }) => bpId === PLUSH_PRODUCT.ID,
  customOption: () => ({
    offset: PLUSH_PRODUCT.OFFSET,
    materialSource: PLUSH_PRODUCT.MATERIAL_SOURCE,
  }),
  stickerizerOptions: () => ({
    afterprocessFn: async (svg: string) => SvgReliefComposer.composeWithRelief(svg, RELIEF_OPTIONS.PLUSH),
    strokeStyle: undefined,
    smoothOffsetAdder: RELIEF_OPTIONS.SMOOTH_OFFSET_ADDER,
    thumbnailExpandMargin: RELIEF_OPTIONS.THUMBNAIL_EXPAND_MARGIN,
    expandMargin: () => {
      const offset = G.mp.maker.flexiMaker?.offsetDistance;

      if (!offset) return 0;
      return RELIEF_OPTIONS.PRINTING_FILE_OFFSET - offset;
    },
  }),
  calOffset: (sliderValue: number) => {
    return mapRange(sliderValue, 0, 1, 17, 20);
  },
  previewImage: {
    imageUrl:
      '//s3.marpple.co/files/u_2798351/2025/10/original/117128b4efc4b694ed187bb5fe4eaedc695cd8a91.png',
    alt: '봉제인형',
  },
};

const MpsJogakStickerProfile: MakerProfile = {
  name: 'mps_jogak_sticker',
  shouldApply: ({ bpId }) => {
    return bpId === JOGAK_STIKER_PRODUCT.ID && G.collabo_type !== '';
  },
  stickerizerOptions: () => ({
    // 마플샵에서는 그림자 효과가 적용되어야함
    afterprocessFn: async (svg: string) => SvgUtil.injectDropShadow(svg),
  }),
};

const PROFILES: MakerProfile[] = [MpsJogakStickerProfile, PlushProfile, DefaultProfile];

export const pickProfile = (ctx: { bpId?: number }) =>
  PROFILES.find((p) => p.shouldApply(ctx)) ?? DefaultProfile;
